export class IntencaoDepositoFilterOptions {
    public q = '';
    public codigo = '';
    public identificador = '';
    public valor = '';
    public datacadastro = '';
    public dataprocessamento = '';
    public datacancelamento; '';
}
